
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.042 17.541l.032.031a.545.545 0 00.447.174.6.6 0 00.443-.222l7.9-10.537a.606.606 0 00.137-.447.593.593 0 00-.218-.4.583.583 0 00-.44-.132.6.6 0 00-.406.217l-7.463 10.05-.146-.147-3.3-3.26a.616.616 0 00-.849.005.6.6 0 000 .85z"}})])
          )
        }
      }
    